export default __webpack_public_path__ + "static/media/treviso.0780cc88.png";